import Vue from "vue";
import AlertComponent from "@erp/shared/components/ui/Unclassified/AlertComponent.vue";
const AlertConstructor = Vue.extend(AlertComponent);
/**
 * 에러 객체에서 메시지 문자열을 추출하는 내부 함수.
 * AxiosError, 중첩 response 객체 등 다양한 형태를 처리한다.
 */
function extractMessage(message) {
    if (typeof message !== "object" || message === null) {
        return String(message);
    }
    const obj = message;
    // userMessage (AxiosError 커스텀 속성) 최우선 사용
    if (typeof obj.userMessage === "string")
        return obj.userMessage;
    // response.response.data (이중 래핑)
    const responseResponse = obj.response?.response;
    if (responseResponse?.data) {
        const data = responseResponse.data;
        const extracted = extractFromData(data);
        if (extracted !== undefined)
            return extracted;
    }
    // response.data (AxiosError)
    const responseData = obj.response?.data;
    if (responseData) {
        const extracted = extractFromData(responseData);
        if (extracted !== undefined)
            return extracted;
    }
    // response (단순 response)
    if (obj.response !== undefined) {
        return typeof obj.response === "string"
            ? obj.response
            : JSON.stringify(obj.response);
    }
    // data
    if (obj.data) {
        const extracted = extractFromData(obj.data);
        if (extracted !== undefined)
            return extracted;
    }
    // msg, failed_info, message, error
    if (typeof obj.msg === "string")
        return obj.msg;
    if (obj.failed_info)
        return extractFailedInfo(obj.failed_info);
    if (typeof obj.message === "string")
        return obj.message;
    if (obj.error) {
        const err = obj.error;
        if (typeof err.message === "string")
            return err.message;
        if (typeof err.msg === "string")
            return err.msg;
        return typeof err === "string" ? err : JSON.stringify(err);
    }
    return JSON.stringify(message);
}
function extractFromData(data) {
    if (typeof data.message === "string")
        return data.message;
    if (typeof data.msg === "string")
        return data.msg;
    if (data.failed_info)
        return extractFailedInfo(data.failed_info);
    if (typeof data === "string")
        return data;
    return undefined;
}
function extractFailedInfo(info) {
    if (typeof info === "string")
        return info;
    const obj = info;
    if (typeof obj.message === "string")
        return obj.message;
    if (typeof obj.msg === "string")
        return obj.msg;
    return JSON.stringify(info);
}
/**
 * 알림 대화상자를 표시한다.
 * 에러 객체, AxiosError, 문자열 등 다양한 형태의 메시지를 자동으로 파싱한다.
 */
export function showAlert(message, title = "알림", timeout = 0) {
    let messageStr;
    if (typeof message !== "object" || message === null) {
        try {
            const parsed = JSON.parse(message);
            messageStr =
                typeof parsed === "object" ? extractMessage(parsed) : String(message);
        }
        catch {
            messageStr = String(message);
        }
    }
    else {
        messageStr = extractMessage(message);
    }
    const modalInstance = new AlertConstructor({
        propsData: { message: messageStr, title, timeout },
    });
    modalInstance.$vuetify =
        Vue.prototype.$vuetify ||
            (Vue.prototype && Vue.prototype.$root && Vue.prototype.$root.$vuetify);
    modalInstance.$mount();
    document.body.appendChild(modalInstance.$el);
    modalInstance.show();
    modalInstance.$on("close", () => {
        document.body.removeChild(modalInstance.$el);
        modalInstance.$destroy();
    });
    return modalInstance;
}
